function AddCell({ dataItem, hidden, onAddClick }) {
    if (hidden) return <td></td>;
    
    function handleAddClick(event) {
        event.preventDefault();
        onAddClick(dataItem.id);
    }

    return (
        <td>
            {dataItem.actionDisplay === "Button Group" && (
                <span
                    className={hidden ? "link add_action text-muted" : "link add_action"}
                    onClick={hidden ? null : handleAddClick}
                >
                    <i className="fas fa-plus" />
                </span>
            )}
        </td>
    );
}

export default AddCell;